import { render, staticRenderFns } from "./PopUpEdit.vue?vue&type=template&id=383fb994&scoped=true&"
import script from "./PopUpEdit.vue?vue&type=script&lang=js&"
export * from "./PopUpEdit.vue?vue&type=script&lang=js&"
import style0 from "./PopUpEdit.vue?vue&type=style&index=0&id=383fb994&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383fb994",
  null
  
)

export default component.exports